// removed by extract-text-webpack-plugin
module.exports = {"description":"app-pages-Employees-Permission-PermissionForm-__PermissionForm___3ZyXi","eye-button":"app-pages-Employees-Permission-PermissionForm-__PermissionForm___h4p3Q","authorization-code-wrapper":"app-pages-Employees-Permission-PermissionForm-__PermissionForm___2x-Nq"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Permission/PermissionForm/PermissionForm.css
// module id = 2093
// module chunks = 0